import { render, staticRenderFns } from "./TinymceEditor.vue?vue&type=template&id=3888a217&scoped=true&"
import script from "./TinymceEditor.vue?vue&type=script&lang=js&"
export * from "./TinymceEditor.vue?vue&type=script&lang=js&"
import style0 from "./TinymceEditor.vue?vue&type=style&index=0&id=3888a217&scoped=true&lang=css&"
import style1 from "./TinymceEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888a217",
  null
  
)

export default component.exports